module.exports = __webpack_public_path__ + "img/messaging.1264d47b.svg";